<template>
  <div>
    <RevButton
      v-if="!orderlineAction.hint"
      :data-qa="`orderline-action-${orderlineAction.type}`"
      :disabled="!orderlineAction.active"
      full-width="always"
      :variant="variant"
      @click="performAction"
    >
      {{ orderlineAction.label }}
    </RevButton>

    <RevPopover v-if="orderlineAction.hint">
      <template #trigger="{ show, hide }">
        <RevButton
          :data-qa="`orderline-action-${orderlineAction.type}`"
          :disabled="!orderlineAction.active"
          full-width="always"
          :variant="variant"
          @click="performAction"
          @focusin="show"
          @focusout="hide"
          @mouseleave="hide"
          @mouseover="show"
        >
          {{ orderlineAction.label }}
        </RevButton>
      </template>

      <template #content="{ position }">
        <RevTooltip :position="position">
          {{ orderlineAction.hint }}
        </RevTooltip>
      </template>
    </RevPopover>
  </div>
</template>

<script lang="ts" setup>
import type { Orderline } from '@backmarket/http-api/src/api-specs-my-orders-api/types/orderlineListResponse'
import { RevButton } from '@ds/components/Button'
import { RevPopover } from '@ds/components/Popover'
import { RevTooltip } from '@ds/components/Tooltip'

import { useOrderlineCardActionsConfig } from '../../../composables/useOrderlineCardActionsConfig'

export interface OrderlineCardActionProps {
  orderlineAction: Orderline['actions'][number]
  orderlineId: Orderline['orderlineId']
  variant: 'primary' | 'secondary'
}

const props = defineProps<OrderlineCardActionProps>()

const { config: orderlineCardActionsConfig } = useOrderlineCardActionsConfig()

async function performAction(): Promise<void> {
  const config = orderlineCardActionsConfig[props.orderlineAction.type](
    props.orderlineAction,
  )

  if (config.onClick) {
    const { onClick } = config

    await onClick({
      orderlineId: props.orderlineId,
    })
  }
}
</script>
